import { AcademicCapIcon, CubeIcon } from "@heroicons/react/24/solid";
import { useTooltip } from "../hooks/useTooltip";
import { Text } from "../ui";

// Constants for header configuration
const DOCS_URL = "https://dev.azure.com/GWS-gevis/Microsoft%20and%20Azure%20Products/_git/cloud-overpass";
const TOOLTIP_ID = "t-help";
const TOOLTIP_LABEL = "help and more";

const HEADER_CLASSES = "flex font-semibold mb-2 h-14 border-b items-center";
const TITLE_CLASSES = "flex grow text-xl cursor-pointer";
const ICON_CLASSES = "w-6 h-6 mr-4 text-black items-center mt-1";
const HELP_BUTTON_CLASSES = "flex items-center bg-gray-200 rounded-md p-0.5 hover:bg-gray-300 cursor-pointer text-sm";
const HELP_ICON_CLASSES = "h-4 w-4 text-sm text-gray-600 mr-1";

// Header title component with logo
const HeaderTitle = () => (
  <Text variant="title" size="xl" className={TITLE_CLASSES}>
    <CubeIcon className={ICON_CLASSES} />
    Overpass
  </Text>
);

// Help documentation link component
const HelpButton = () => (
  <div id={TOOLTIP_ID} className={HELP_BUTTON_CLASSES}>
    <AcademicCapIcon className={HELP_ICON_CLASSES} />
    <a href={DOCS_URL} target="_blank" rel="noreferrer">
      docs
    </a>
  </div>
);

// Application header with title and help link
export const Header = () => {
  const { addTooltip } = useTooltip();
  
  // Register tooltip for help button
  addTooltip({
    id: TOOLTIP_ID,
    label: TOOLTIP_LABEL
  });

  return (
    <div className={HEADER_CLASSES}>
      <HeaderTitle />
      <HelpButton />
    </div>
  );
};